<div class="row col-md-10 col-xs-10 col-md-offset-1 col-xs-offset-1">
  <div class="row col-xs-offset-2">
    <div class="col-md-2" >
      <button class="btnAdminManage btn-create btn-cons" (click)="addLeave()" >Add Leave</button>
    </div>
    <div class="col-md-2" >
      <button class="btnAdminManage btn-create btn-cons"  (click)="modifyPassword()">Password</button>
    </div>
    <div class="col-md-2 " >
      <button class="btnAdminManage btn-create btn-cons"  (click)="addAvatar()">Add Avatar</button>
    </div>
    <div class="col-md-2 " >
      <button class="btnAdminManage btn-create btn-cons"  (click)="delAvatar()">Delete avatar</button>
    </div>
    <div class="col-md-2 " >
      <button class="btnAdminManage btn-create btn-cons"  (click)="socialEvent()">Social event</button>
    </div>
    <div class="row col-md-12">
      @if (seeLeave) {
        <div ><br/><br/><br/>
          <div class="hidden-xs" style="text-align:center;">
            <p>LEAVE :</p>
            <br/><br/>
            <img src="../../../css/images/leave.gif" width="1920" height="1080">
          </div>
          <div class="visible-xs col-xs-offset-1">
            <p>LEAVE</p>
            <img src="../../../css/images/leaveM.gif">
          </div>
        </div>
      }
      @if (seePassword) {
        <div ><br/><br/><br/>
          <div class="hidden-xs" style="text-align:center;">
            <p>NEW PASSWORD : </p>
            <br/><br/>
            <img src="../../../css/images/pwd.gif" width="1920" height="1080">
          </div>
          <div class="visible-xs col-xs-offset-1">
            <p>NEW PASSWORD</p>
            <img src="../../../css/images/pwdM.gif">
          </div>
        </div>
      }
    </div>
    <div class="row col-md-12">
      @if (seeAddAvatar) {
        <div><br/><br/><br/>
          <div class="hidden-xs" style="text-align:center;">
            <p>CHOOSE AVATAR : </p>
            <br/><br/>
            <img src="../../../css/images/avatar.gif" width="1920" height="1080"> <br/>
            <i class="material-icons" style="color:red;">warning</i><span style="font-weight: 500;">L'avatar doit faire 50px / 50 px et moins de 10Kb</span><br/><br/>
          </div>
          <div class="visible-xs col-xs-offset-1">
            <p>CHOOSE AVATAR</p>
            <img src="../../../css/images/avatarM.gif">
          </div>
        </div>
      }
      @if (seeDelAvatar) {
        <div ><br/><br/><br/>
          <div class="hidden-xs" style="text-align:center;">
            <p>DELETE AVATAR : </p>
            <br/><br/>
            <img src="../../../css/images/delAvatar.gif" width="1920" height="1080">
          </div>
          <div class="visible-xs col-xs-offset-1">
            <p>DELETE AVATAR  </p>
            <img src="../../../css/images/delAvatarM.gif">
          </div>
        </div>
      }
    </div>
    <br/>
    <div class="row col-md-12">
      @if (seeSocialEvent) {
        <div><br/><br/><br/>
          <div class="hidden-xs" style="text-align:center;">
            <p>ACCEPT OR REFUSE SOCIAL EVENT</p>
            <br/><br/>
            <img src="../../../css/images/SE.gif" width="1920" height="1080">
          </div>
          <div class="visible-xs col-xs-offset-1">
            <p>ACCEPT OR REFUSE SOCIAL EVENT</p>
            <img src="../../../css/images/SEm.gif">
          </div>
        </div>
      }
    </div>
  </div>
